import {
  REHYDRATE_DONE
} from '../actions/rehydrate';

const INITIAL_STATE = {
  value: null
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case REHYDRATE_DONE:
      return Object.assign({}, state, {value: action.value});
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/rehydrate.js